var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanetSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.84,
    cy: 124.46,
    r: 51.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157,106c25.32,3.86,42.13,10.68,42.13,18.44,0,12-40.4,21.79-90.24,21.79S18.6,136.49,18.6,124.46c0-7.75,16.77-14.56,42-18.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.63,43.59a21.54,21.54,0,0,0,15.46-15.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.5,43.59a21.54,21.54,0,0,1-15.45-15.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.5,43.79a21.54,21.54,0,0,0-15.45,15.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.63,43.79a21.54,21.54,0,0,1,15.46,15.46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetSpace);
export default __webpack_public_path__ + "static/media/PLANET_SPACE.cd7b1dcca730175a62272f447433d8e1.svg";
export { ForwardRef as ReactComponent };